import React, { useState } from "react";
import { Viewer, Worker } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";

import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";

const PdfViewerUpload2 = () => {
  const [pdfFile, setPdfFile] = useState(null);
  const defaultLayoutPluginInstance = defaultLayoutPlugin();

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file?.type === "application/pdf") {
      setPdfFile(URL.createObjectURL(file));
    } else {
      alert("Please upload a valid PDF file");
    }
  };

  const handleRemove = () => {
    setPdfFile(null);
  };

  return (
    <div style={{ padding: "20px" }}>
      <h4>Upload PDF</h4>

      {!pdfFile && (
        <input type="file" accept="application/pdf" onChange={handleFileUpload} />
      )}

      {pdfFile && (
        <>
          <button
            onClick={handleRemove}
            style={{
              marginBottom: "10px",
              background: "red",
              color: "white",
              padding: "6px 10px",
              border: "none",
              cursor: "pointer",
            }}
          >
            Remove PDF
          </button>

          <Worker workerUrl={`${process.env.PUBLIC_URL}/pdf.worker.min.js`}>
            <div style={{ height: "750px" }}>
              <Viewer
                fileUrl={pdfFile}
                plugins={[defaultLayoutPluginInstance]}
              />
            </div>
          </Worker>
        </>
      )}
    </div>
  );
};

export default PdfViewerUpload2;